/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Machine_Id_Copied_ToastInputs */

const en_login_offline_machine_id_copied_toast = /** @type {(inputs: Login_Offline_Machine_Id_Copied_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine Id copied to clipboard successfully.`)
};

const fr_login_offline_machine_id_copied_toast = /** @type {(inputs: Login_Offline_Machine_Id_Copied_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiant machine copie dans le presse-papiers.`)
};

const de_login_offline_machine_id_copied_toast = /** @type {(inputs: Login_Offline_Machine_Id_Copied_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Maschinen-ID wurde erfolgreich in die Zwischenablage kopiert.`)
};

const it_login_offline_machine_id_copied_toast = /** @type {(inputs: Login_Offline_Machine_Id_Copied_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID macchina copiato correttamente negli appunti.`)
};

const ru_login_offline_machine_id_copied_toast = /** @type {(inputs: Login_Offline_Machine_Id_Copied_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор машины успешно скопирован в буфер обмена.`)
};

const es_login_offline_machine_id_copied_toast = /** @type {(inputs: Login_Offline_Machine_Id_Copied_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Id. de la máquina copiada al portapapeles exitosamente.`)
};

const zh_cn2_login_offline_machine_id_copied_toast = /** @type {(inputs: Login_Offline_Machine_Id_Copied_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`机器ID已成功复制到剪贴板。`)
};

const ja_login_offline_machine_id_copied_toast = /** @type {(inputs: Login_Offline_Machine_Id_Copied_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マシン ID がクリップボードに正常にコピーされました。`)
};

const hi_login_offline_machine_id_copied_toast = /** @type {(inputs: Login_Offline_Machine_Id_Copied_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मशीन आईडी सफलतापूर्वक क्लिपबोर्ड पर कॉपी हो गई।`)
};

const pt_pt2_login_offline_machine_id_copied_toast = /** @type {(inputs: Login_Offline_Machine_Id_Copied_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID da máquina copiado com sucesso para a área de transferência.`)
};

/**
* | output |
* | --- |
* | "Machine Id copied to clipboard successfully." |
*
* @param {Login_Offline_Machine_Id_Copied_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_machine_id_copied_toast = /** @type {((inputs?: Login_Offline_Machine_Id_Copied_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Machine_Id_Copied_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_machine_id_copied_toast(inputs)
	if (locale === "de") return de_login_offline_machine_id_copied_toast(inputs)
	if (locale === "it") return it_login_offline_machine_id_copied_toast(inputs)
	if (locale === "ru") return ru_login_offline_machine_id_copied_toast(inputs)
	if (locale === "es") return es_login_offline_machine_id_copied_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_machine_id_copied_toast(inputs)
	if (locale === "ja") return ja_login_offline_machine_id_copied_toast(inputs)
	if (locale === "hi") return hi_login_offline_machine_id_copied_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_machine_id_copied_toast(inputs)
	return en_login_offline_machine_id_copied_toast(inputs)
});